import * as Select from "@radix-ui/react-select";
import { useState } from "react";
import NumberDropdownContent from "./components/numberDropdownContent";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

interface Props {
  min?: number;
  max: number;
  selectedNumber: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  isPortal?: boolean;
}

export default function NumberDropdown({
  min = 1,
  max,
  selectedNumber,
  onChange,
  disabled,
  isPortal = false,
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Select.Root
      open={open}
      onOpenChange={setOpen}
      value={selectedNumber.toString()}
      onValueChange={(value) => onChange(parseInt(value))}
    >
      <Select.Trigger
        className="relative px-4 text-sm leading-none text-black border rounded shadow-sm cursor-default disabled:cursor-not-allowed w-full h-9 focus:outline-none focus:ring-1 focus:ring-indigo-500 transition-colors ease-in-out duration-200 bg-white border-gray-300 hover:bg-gray-100 disabled:bg-gray-200 disabled:text-gray-500 focus:border-indigo-500"
        disabled={disabled}
      >
        <div className="inline-flex items-center justify-center gap-1">
          <Select.Value>{selectedNumber}</Select.Value>
          <Select.Icon>
            <ChevronDownIcon className="w-4 h-4" />
          </Select.Icon>
        </div>
      </Select.Trigger>
      {isPortal ? (
        <Select.Portal>
          <NumberDropdownContent max={max} min={min} />
        </Select.Portal>
      ) : (
        <NumberDropdownContent max={max} min={min} />
      )}
    </Select.Root>
  );
}
